import {Injectable} from '@angular/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {filter} from 'rxjs/operators';

@Injectable()
export class PromptUpdateService {

  constructor() {
  }

}
